import { render, staticRenderFns } from "./exemptionUnderSectionDeduction.vue?vue&type=template&id=72ff4ed9&scoped=true"
import script from "./exemptionUnderSectionDeduction.vue?vue&type=script&lang=js"
export * from "./exemptionUnderSectionDeduction.vue?vue&type=script&lang=js"
import style0 from "./exemptionUnderSectionDeduction.vue?vue&type=style&index=0&id=72ff4ed9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ff4ed9",
  null
  
)

export default component.exports